<template>
  <div class="post-detail">
    <div class="post-header">
      <h3>
        {{post.post}}
        <em class="salary">{{post.salary}}</em>
      </h3>
      <p class="j-addition">
        <span><em class="jb-loc"></em>{{post.place}}</span>
      </p>
      <p>
        <time>{{post.gmtPublish}}</time>
      </p>
    </div>

    <ul class="jobduty">
      <li class="duty-title">岗位职责</li>
      <li v-html="post.responsibility"></li>
    </ul>
    <ul class="jobduty">
      <li class="duty-title">任职资格</li>
      <li v-html="post.requirements"></li>
    </ul>

    <div class="jobs-slogan">
      <p>我们正在做一件改变中国民生服务方式的事情。
      </p>
      <p>在这里，有优秀的领导和有意思的同事，让你发现身边志同道合的人；在这里，小伙伴们都充满活力和激情。</p>
      <p>
        欢迎加入我们，和我们一起成长，一起享受工作带来的乐趣，一起做有意思的事吧~
      </p>

      <ul>
        <li>联系人：张经理</li>
        <li>咨询电话：010-62680078</li>
        <li>咨询邮箱：hr@bjewaytek.com</li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        post: null
      }
    },
    created () {
      this.post = this.$route.params.data;
    }
  }
</script>

<style lang="scss">
  @import '../assets/style/base.scss';
  @import '../assets/style/public.scss';

  .post-detail{
    @include c-wrap();
    background: #fff;
    .post-header{
      padding-top: .20rem;
      padding-bottom: .50rem;
      border-bottom: 1px solid #e5e5e5;
      h3{
        font-size: .34rem;
        color: #3b3b3b;
        font-weight: lighter;
        margin-bottom: .32rem;
        .salary{
          float: right;
          font-size: .30rem;
          color: #ea3e3e;
        }
      }
      .j-addition {
        margin-bottom: .25rem;
        span{
          font-size: .24rem;
          color: #878787;
          border-left: 1px solid #e5e5e5;
          padding-left: .20rem;
          padding-right: .20rem;
          &:first-child{
            padding-left: 0;
            border-left: 0;
          }
        }
        .jb-loc{
          display: inline-block;
          width: .20rem;
          height: .25rem;
          background: url('../assets/images/jb-loc.png') no-repeat center center;
          -webkit-background-size: contain;
          background-size: contain;
          margin-right: .08rem;
        }
      }
      time{
        display: inline-block;
        font-size: .22rem;
        color: #c6c6c6;
        line-height: .34rem;
        padding: 0 .15rem;
        background: #f5f5f5;
        border-radius: 4px;
      }
    }
    .jobduty{
      padding: 0 .20rem;
      .duty-title{
        font-size: .34rem;
        color: #3b3b3b;
        margin-top: .50rem;
        margin-bottom: .50rem;
      }
      p{
        color: #3b3b3b;
        font-size: .30rem;
        line-height: .55rem;
      }
    }

    .jobs-slogan{
      margin-top: .60rem;
      border-top: 1px dashed #e5e5e5;
      padding-top: .70rem;
      p{
        font-size: .30rem;
        color: #969696;
        line-height: 1.8em;
        margin-bottom: .50rem;
      }
      ul{
        margin-top: 1.40rem;
        padding-bottom: 1.32rem;
        li{
          font-size: .30rem;
          color: #979797;
          margin-bottom: .36rem;
          &:last-child{
            margin-bottom: 0;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/mobile/JoinDetail.vue